module.exports = __webpack_public_path__ + "static/media/Nguyen_Dong_Duc_Anh.420a6b83.jpg";